import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAPISettingsApi } from './use-api-settings-api';
import { QK_API_SETTINGS_LIST_KEYS } from './use-api-settings-keys';

export function useAPISettingsCreate() {
  const { APISettingsApi } = useAPISettingsApi();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (name: string) => await APISettingsApi.create(name),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: QK_API_SETTINGS_LIST_KEYS() });
    },
  });
}
